import Footer from "../../components/footer"
import Menu from "../../components/menu"
import useAuth from "../../hooks/useAuth"

import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query"
import { authApi } from "../../services/api/api"

import FilterAltIcon from '@mui/icons-material/FilterAlt';
import PostAddIcon from '@mui/icons-material/PostAdd';
import DoneAllIcon from '@mui/icons-material/DoneAll';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import confetti from 'canvas-confetti';

import { useEffect, useRef, useState } from "react"
import Post from "../../components/post"
import { ToastContainer, toast } from "react-toastify"

import { useInView } from 'react-intersection-observer';
import SkeletonIndications from "../../components/skeletons/indications"

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import TextEditor from "../../components/textEditor"
import { CloudUploadIcon, FilePlusCorner, Filter, ListFilterPlus } from "lucide-react"
import ScrollToTop from "../../components/scrollToTop"
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

export default function Forum() {

    const { ref, inView } = useInView();

    const api = authApi()

    const [value, setValue] = useState(null);
    const [inputValue, setInputValue] = useState('');

    const [users, setUsers] = useState([]);

    const [label, setLabel] = useState(false);

    useEffect(() => {
        async function getUsers() {
            const data = await api.selectUser()
            setUsers(data)
            setLabel(true)
        }
        getUsers()
    }, [])

    const [start, setstart] = useState('')
    const [end, setEnd] = useState('')

    const [filtro, setFiltro] = useState(null)

    const { user, theme } = useAuth()

    const [comment, setComment] = useState(false)

    const [page, setPage] = useState(0)

    const [lastPage, setlastPage] = useState(false)

    const [atualizar, setAtualizar] = useState(false)

    const [textNewPost, setTextNewPost] = useState('')

    const inputNewPost = useRef(null)

    const [imgNewPost, setImgNewPost] = useState('');

    const [titleBook, setTitleBook] = useState('');

    const [open, setOpen] = useState(false);

    const themeMui = useTheme();

    const isMobile = useMediaQuery(themeMui.breakpoints.down('sm'));

    const handleClickOpen = async () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [openNewPost, setOpenNewPost] = useState(false);

    const handleClickOpenNewPost = async () => {
        setOpenNewPost(true);
    };

    const handleCloseNewPost = () => {
        setOpenNewPost(false);
    };


    const getData = async ({ pageParam }) => {

        setlastPage(pageParam.last_pages)

        const data = await api.getPosts(pageParam.nextPage, filtro)

        return data
    }

    const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery({
        queryKey: ['indications', comment, atualizar, filtro],
        queryFn: getData,
        // placeholderData:keepPreviousData, 
        initialPageParam: 1,
        getNextPageParam: (lastPage, allPages) => {

            const nextPage = allPages.length + 1

            let last_pages = false

            if (nextPage >= lastPage.last_page) {
                last_pages = true
            } else {
                last_pages = false
            }

            return { nextPage, last_pages }

        }
    })

    useEffect(() => {

        if (inView && !lastPage) {
            fetchNextPage()
        }
    }, [inView, fetchNextPage, lastPage, isFetchingNextPage])


    async function handleSetPostComment(data: any) {

        const response = await api.setCommentPost(data)

        if (response === 200) {
            setComment(!comment)
        }

    }

    function handleFilter() {
        setFiltro({ start, end, inputValue })
        handleClose()
    }


    async function handleSetImgPost() {
        if (inputNewPost) {
            inputNewPost.current?.click()
        }
    }

    function handleSetImage(e: React.ChangeEvent<HTMLInputElement>) {

        const selectedFiles = e.target.files

        if (selectedFiles?.[0].size > 1048576) {
            toast.error('A imagem não pode ultrapassar 1mb.', { theme: 'dark', toastId: 'password' })
            return
        }

        if (e.target.files) {

            const files = e.target.files[0]

            const reader = new FileReader()
            reader.readAsBinaryString(e.target.files[0])
            reader.onload = (ev: any) => {
                setImgNewPost(`data:${files.type};base64,${btoa(ev.target.result)}`)
            }
        }
    }

    async function handleSetNewPost() {

        if (textNewPost == '' || imgNewPost == '' || titleBook == '') {
            toast.error('Adicione uma capa de livro e um texto.', { theme: 'dark', toastId: 'errorNewPost' })
            return
        }

        toast.loading('Carregando...', { theme: 'dark', toastId: 'sendPost' })

        const dados = { text: textNewPost, img: imgNewPost, user: user.id, title: titleBook }


        const result = await api.setNewPost(dados)
        if (result) {
            toast.dismiss('sendPost')
            toast.dismiss('errorNewPost')
            toast.success('Post criado com sucesso!', { theme: 'dark', toastId: 'sendPostsuccess' })

            triggerConfetti();
            setTitleBook('')
            setImgNewPost('')
            setAtualizar(old => !old)
        } else {
            toast.dismiss('sendPost')
            toast.dismiss('errorNewPost')
            toast.error('Houve algum erro, tente novamente mais tarde', { theme: 'dark', toastId: 'sendPosterror' })
        }
        handleCloseNewPost()

    }
    // Função estilizada para os confetes (com as cores do seu projeto)
    const triggerConfetti = () => {
        const duration = 3 * 1000;
        const animationEnd = Date.now() + duration;
        const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 9999 };

        const randomInRange = (min: number, max: number) => Math.random() * (max - min) + min;

        const interval: any = setInterval(function () {
            const timeLeft = animationEnd - Date.now();

            if (timeLeft <= 0) {
                return clearInterval(interval);
            }

            const particleCount = 50 * (timeLeft / duration);

            // Solta confetes de dois pontos laterais
            confetti({
                ...defaults,
                particleCount,
                origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
                colors: ['#195AB4', '#ffffff', '#60A5FA'] // Cores azuladas do seu tema
            });
            confetti({
                ...defaults,
                particleCount,
                origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
                colors: ['#195AB4', '#ffffff', '#60A5FA']
            });
        }, 250);
    };
    return (
        <div className={`main w-screen bg-white ${theme} overflow-x-hidden`}>
            <Menu />
            <div className="content w-screen min-h-screen flex justify-center dark:bg-[#061c3f]">
                <div className="max-w-[1800px] w-full flex justify-center mb-8 p-8">
                    <div className="w-full ">
                        <div className="w-full mb-8">
                            <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">

                                {/* Lado Esquerdo: Identidade Visual Padronizada */}
                                <div className="flex flex-col gap-1">
                                    <h4 className="text-slate-400 dark:text-slate-500 text-[10px] font-bold uppercase tracking-[0.3em]">
                                        Comunidade
                                    </h4>
                                    <h2 className="text-xl font-bold text-slate-800 dark:text-white tracking-tight">
                                        Fórum de Discussões
                                    </h2>

                                </div>

                                {/* Lado Direito: Ações (Novo Post e Filtro) */}
                                <div className="flex items-center gap-3">
                                    <button
                                        onClick={handleClickOpenNewPost}
                                        className="flex items-center gap-2 px-4 h-10 bg-blue3 hover:bg-blue4 text-white rounded-xl shadow-sm transition-all active:scale-95"
                                    >
                                        <FilePlusCorner size={17} />
                                        <span className="text-[11px] font-bold uppercase tracking-wider">Novo Post</span>
                                    </button>

                                    <button
                                        onClick={handleClickOpen}
                                        className="p-2.5 bg-white dark:bg-slate-700 text-slate-500 dark:text-slate-300 rounded-xl border border-gray-100 dark:border-white/10 shadow-sm hover:bg-gray-50 dark:hover:bg-slate-600 transition-all"
                                    >
                                        <ListFilterPlus size={17} />
                                    </button>
                                </div>
                            </div>

                            {/* Divisor Padrão */}
                            <div className="w-full h-[1px] bg-gray-100 dark:bg-slate-600 mt-4"></div>
                        </div>
                        {data?.pages ? (data?.pages.map((items) => items.data.map((item) => <Post atualizar={atualizar} setAtualizar={setAtualizar} key={item.id} post={item} handleSetPostComment={handleSetPostComment} />)))
                            : <SkeletonIndications />}
                        {isFetchingNextPage ? <SkeletonIndications /> : ''}
                        <span ref={ref} className="text-gray-400"></span>
                    </div>
                </div>
            </div>





            <ToastContainer />
            <ScrollToTop />

            {/* <Footer/> */}
            <div className="w-full h-8 dark:bg-slate-800"></div>
            <Dialog
                open={open}
                onClose={handleClose}
                fullScreen={isMobile}
                PaperProps={{
                    style: {
                        borderRadius: isMobile ? 0 : '24px',
                        backgroundImage: 'none',
                        maxWidth: '500px',
                        width: '100%',
                        overflow: 'hidden',
                    },
                }}
            >
                {/* Header Padronizado */}
                <div className="bg-gradient-to-r from-[#001e42] to-blue3 px-6 py-5 border-b border-white/10 shadow-lg">
                    <div className="flex items-center gap-4">
                        <div className="bg-white/10 p-2.5 rounded-xl backdrop-blur-md border border-white/20">
                            <Filter className="text-white" style={{ fontSize: 22 }} />
                        </div>
                        <div>
                            <span className="text-[10px] uppercase font-bold tracking-[0.3em] text-blue-200/70 block mb-0.5">
                                Refinar Busca
                            </span>
                            <h3 className="text-xl font-bold text-white leading-tight">
                                Filtrar Resultados
                            </h3>
                        </div>
                    </div>
                </div>

                <DialogContent className="pt-8">
                    <div className="flex flex-col gap-6">

                        {/* Seleção de Usuário */}
                        <div className="flex flex-col gap-2">
                            <label className="text-[10px] uppercase font-bold tracking-widest text-gray-400 ml-1">
                                Filtrar por Usuário
                            </label>
                            <Autocomplete
                                value={value}
                                onChange={(event: any, newValue: string | null) => setValue(newValue)}
                                inputValue={inputValue}
                                onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
                                options={users?.map((item) => item.email) || []}
                                fullWidth
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder={label ? "Selecione o e-mail..." : ""}
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {!label ? <CircularProgress color="inherit" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '12px',
                                                backgroundColor: '#f9fafb',
                                                '& fieldset': { border: 'none' },
                                                '&:hover fieldset': { border: 'none' },
                                                '&.Mui-focused fieldset': { border: 'none' },
                                                fontSize: '0.875 m',
                                            }
                                        }}
                                    />
                                )}
                            />
                        </div>

                        {/* Seleção de Datas */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="flex flex-col gap-2">
                                <label className="text-[10px] uppercase font-bold tracking-widest text-gray-400 ml-1">
                                    Data Inicial
                                </label>
                                <input
                                    type="date"
                                    className="w-full h-12 px-4 rounded-xl border-2 border-gray-100 dark:border-white/5 bg-gray-50 dark:bg-white/5 dark:text-white outline-none focus:border-blue-500/50 transition-all text-sm"
                                    onChange={(e) => setstart(e.target.value)}
                                />
                            </div>
                            <div className="flex flex-col gap-2">
                                <label className="text-[10px] uppercase font-bold tracking-widest text-gray-400 ml-1">
                                    Data Final
                                </label>
                                <input
                                    type="date"
                                    className="w-full h-12 px-4 rounded-xl border-2 border-gray-100 dark:border-white/5 bg-gray-50 dark:bg-white/5 dark:text-white outline-none focus:border-blue-500/50 transition-all text-sm"
                                    onChange={(e) => setEnd(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                </DialogContent>

                <DialogActions className="p-6 pt-2 border-t-gray-100 border">
                    <div className="flex w-full gap-4 my-2">
                        <button
                            onClick={handleClose}
                            className="flex-1 h-12 text-xs font-bold text-gray-400 hover:text-red-500 transition-colors tracking-widest uppercase"
                        >
                            Cancelar
                        </button>
                        <button
                            onClick={handleFilter}
                            className="flex-1 px-2 h-12 bg-blue3 hover:bg-blue4 text-white text-xs font-bold rounded-xl transition-all active:scale-95 uppercase tracking-widest flex items-center justify-center gap-2"
                        >
                            Aplicar Filtro
                        </button>
                    </div>
                </DialogActions>
            </Dialog>

            <Dialog

                open={openNewPost}
                onClose={handleCloseNewPost}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullScreen={isMobile}
            
                PaperProps={{
                    style: {
                        borderRadius: isMobile ? '0px' : '24px',
                        backgroundImage: 'none',
                        maxWidth: '700px',
                        width: '100%',
                        overflow: 'hidden'
                    },
                }}

            >
                {/* Header Padronizado */}
                <div className="bg-gradient-to-r from-[#001e42] to-blue3 px-6 py-5 border-b border-white/10 shadow-lg">
                    <div className="flex items-center gap-4">
                        <div className="bg-white/10 p-2.5 rounded-xl backdrop-blur-md border border-white/20">
                            <PostAddIcon className="text-white" style={{ fontSize: 22 }} />
                        </div>
                        <div>
                            <span className="text-[10px] uppercase font-bold tracking-[0.3em] text-blue-200/70 block mb-0.5">
                                Contribuição Externa
                            </span>
                            <h3 className="text-xl font-bold text-white leading-tight">
                                Escrever Novo Post
                            </h3>
                        </div>
                    </div>
                </div>

                <DialogContent className="pt-6">
                    <div className="flex flex-col gap-6">

                        {/* Seção Superior: Título e Capa lado a lado */}
                        <div className="flex flex-col md:flex-row gap-4 items-start">
                            {/* Input de Título */}
                            <div className="flex-1 w-full flex flex-col gap-2">
                                <label className="text-[10px] uppercase font-bold tracking-widest text-gray-400 ml-1">
                                    Título da Obra
                                </label>
                                <input
                                    type="text"
                                    placeholder="Ex: O Pequeno Príncipe"
                                    className="w-full h-11 px-4 rounded-xl border-2 border-gray-100 dark:border-white/5 bg-gray-50 dark:bg-white/5 dark:text-white outline-none focus:border-blue-500/50 transition-all text-sm"
                                    onChange={e => setTitleBook(e.target.value)}
                                    value={titleBook}
                                />
                            </div>

                            {/* Botão de Capa Estilizado */}
                            <div className="w-full md:w-auto flex flex-col gap-2">
                                <label className="text-[10px] uppercase font-bold tracking-widest text-gray-400 ml-1">
                                    Capa do Livro
                                </label>
                                <button
                                    onClick={handleSetImgPost}
                                    className={`h-11 px-4 rounded-xl border-2 flex items-center justify-center gap-2 transition-all text-[11px] font-bold uppercase tracking-wider
                            ${imgNewPost !== ''
                                            ? 'border-green-500/50 bg-green-500/10 text-green-600'
                                            : 'border-dashed border-gray-300 dark:border-white/20 text-gray-500 hover:border-blue-500/50'}`}
                                >
                                    {imgNewPost !== '' ? <DoneAllIcon fontSize="small" /> : <CloudUploadIcon fontSize="small" />}
                                    {imgNewPost !== '' ? 'Capa Selecionada' : 'Upload da Capa'}
                                    <input type="file" accept="image/*" className="hidden" ref={inputNewPost} onChange={e => handleSetImage(e)} />
                                </button>
                            </div>
                        </div>

                        {/* Editor de Texto */}
                        <div className="flex flex-col gap-2">
                            <label className="text-[10px] uppercase font-bold tracking-widest text-gray-400 ml-1">
                                Conteúdo da Publicação
                            </label>
                            <div className="rounded-2xl border-2 border-gray-100 dark:border-white/5 overflow-hidden bg-white shadow-inner">
                                <TextEditor setText={setTextNewPost} />
                            </div>
                        </div>
                    </div>
                </DialogContent>

                <DialogActions className="p-6 pt-2 flex gap-4 border-t-gray-100 border">
                    <div className="flex w-full my-2">
                        <button
                            onClick={handleCloseNewPost}
                            className="flex-1 h-12 text-xs font-bold text-gray-400 hover:text-gray-600 dark:hover:text-white transition-colors tracking-widest uppercase"
                        >
                            Descartar
                        </button>
                        <button
                            onClick={handleSetNewPost}
                            className="flex-1 px-2 h-12 bg-blue3 hover:bg-blue4 text-white text-xs font-bold rounded-xl shadow-lg shadow-blue-500/30 transition-all active:scale-95 uppercase tracking-widest flex items-center justify-center gap-2"
                        >
                            Publicar no Fórum
                        </button>
                    </div>
                </DialogActions>
            </Dialog>
        </div>
    )
}